import React, { Component } from 'react'
import { FormikInputField } from '../../components/form/InputField'
import { Formik, Form  } from 'formik'
import FormCard from '../../components/layout/FormCard'
import * as Yup from 'yup'
import { FormikCheckboxField } from '../../components/form/CheckboxField'
import { Button } from '@material-ui/core'

const validationSchema = Yup.object().shape({
    gallery_name: Yup.string(),
    session_name: Yup.string(),
})

class AdminGalleryForm extends Component {


  render() {
    const {
      onSave,
      gallery,
      initial_values,
    } = this.props


    return (
      <Formik
        enableReinitialize
        onSubmit={ onSave }
        initialValues={ initial_values }
        validationSchema={ validationSchema }
      >
        {(formik_props) => {
          const { values } = formik_props
          return (
            <Form>
              <FormCard>
                <FormikInputField
                  name='gallery_name'
                  type='text'
                  label='Gallery Name'
                  formik_props={ formik_props }
                />
              </FormCard>
              <FormCard>
                <FormikInputField
                  type='text'
                  name='session_name'
                  label='Session Name'
                  formik_props={ formik_props }
                />
              </FormCard>
              <FormCard>
                <FormikInputField
                  type='text'
                  name='description'
                  label='Description'
                  formik_props={ formik_props }
                />
              </FormCard>
              <FormCard>
                <FormikInputField
                  type='text'
                  name='tags'
                  label='Tags'
                  formik_props={ formik_props }
                />
              </FormCard>
              <FormCard>
                <FormikInputField
                  type='number'
                  name='rating'
                  label='Rating'
                  formik_props={ formik_props }
                />
              </FormCard>
              <FormCard>
                <FormikCheckboxField
                  name='available_to_purchase'
                  type='checkbox'
                  checked={ values.available_to_purchase }
                  label='Available to Purchase'
                  formik_props={ formik_props }
                />
              </FormCard>
              <FormCard>
                <Button
                  fullWidth
                  type='submit'
                  size='large'
                  color='primary'
                  variant='contained'
                >
                  Save
                </Button>
              </FormCard>
            </Form>
          )
        }}
      </Formik>
    )
  }
}
export default AdminGalleryForm;
